//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'm-question',
  data () {
    return {
      showMore: false
    }
  },
  computed: {
    allQuestions () {
      if (this.$store.state.config.questions) return this.$store.state.config.questions
      return []
    },
    questions () {
      if (this.showMore) {
        return this.allQuestions
      } else {
        return this.allQuestions.slice(0, 2)
      }
    },
    moreTips () {
      if (this.showMore) {
        return '收起全部'
      } else {
        return '查看更多(' + (this.allQuestions.length - 2) + ')'
      }
    },
    questionIcon () {
      if (this.$store.state.config.questionIcon) {
        return this.$store.state.config.questionIcon
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Question.vue